import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityListPage } from "../shared/EntityListPage";

export function SuppliersListPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityListPage
      entityType="supplier"
      detailBasePath={`${adminPath}/mdm/suppliers`}
    />
  );
}
